import { render, staticRenderFns } from "./defectsDealList.vue?vue&type=template&id=321daf9a&scoped=true"
import script from "./defectsDealList.vue?vue&type=script&lang=js"
export * from "./defectsDealList.vue?vue&type=script&lang=js"
import style0 from "./defectsDealList.vue?vue&type=style&index=0&id=321daf9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321daf9a",
  null
  
)

export default component.exports